import { render } from "./item-bonus.vue?vue&type=template&id=4ebd5c55&scoped=true"
import script from "./item-bonus.vue?vue&type=script&lang=js"
export * from "./item-bonus.vue?vue&type=script&lang=js"

import "./item-bonus.vue?vue&type=style&index=0&id=4ebd5c55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebd5c55"]])

export default __exports__